export enum EmptyStateGraphic {
    AccountInvoices = 'assets/images/emptystates/FamiliesInvoicesV2026-10-23.svg',
    Agenda = 'assets/images/emptystates/AgendaV2026-10-23.svg',
    AttendanceNotes = 'assets/images/emptystates/Attendance-DefaultV2026-10-23.svg',
    AttendanceNoHistory = 'assets/images/emptystates/NoHistoryV2026-10-23.svg',
    AttendanceNoTemplates = 'assets/images/emptystates/NoTemplatesV2026-10-23.svg',
    BackToLegacyWebsiteBuilder = 'assets/images/emptystates/Back-To-LegacyV2026-10-23.svg',
    BorrowingLibrary = 'assets/images/emptystates/NoLibraryV2026-10-23.svg',
    Calendar = 'assets/images/emptystates/NoEventsV2026-10-23.svg',
    CalendarBookingBlocked = 'assets/images/emptystates/BlockedBookingV2026-10-23.svg',
    ChargeCategories = 'assets/images/emptystates/ChargeCategoriesV2026-10-23.svg',
    ExpensesRevenue = 'assets/images/emptystates/ExpensesRevenueV2026-10-23.svg',
    ExpiredTrial = 'assets/images/emptystates/ExpiredTrialV2026-10-23.svg',
    FamilyAccounts = 'assets/images/emptystates/FamiliesInvoices-FamilyAccountsV2026-10-23.svg',
    Invoices = 'assets/images/emptystates/FamiliesInvoicesV2026-10-23.svg',
    HomeHeader = 'assets/images/Home-Header-GraphicV2026-10-23.svg',
    Homework = 'assets/images/emptystates/AddHomeworkV2026-10-23.svg',
    HomeworkFeedback = 'assets/images/emptystates/AddHomeworkFeedbackV2026-10-23.svg',
    LendingLibrary = 'assets/images/emptystates/NoLibraryV2026-10-23.svg',
    LendingLibraryHistory = 'assets/images/emptystates/LendingLibraryHistoryV2026-10-23.svg',
    Locations =  'assets/images/emptystates/LocationsV2026-10-23.svg',
    Membership = 'assets/images/emptystates/PayrollHistoryV2026-10-23.svg',
    MessageHistory = 'assets/images/emptystates/MessageHistoryV2026-10-23.svg',
    News = 'assets/images/emptystates/NewsV2026-10-23.svg',
    NoEvents = 'assets/images/emptystates/NoEventsV2026-10-23.svg',
    NoResultsFound = 'assets/images/emptystates/NoResultsFoundV2026-10-23.svg',
    Notifications = 'assets/images/emptystates/NoNotificationsV2026-10-23.svg',
    OnlineResources = 'assets/images/emptystates/OnlineResourcesV2026-10-23.svg',
    PaymentProcessor = 'assets/images/emptystates/RecentTransactionsV2026-10-23.svg',
    Packages = 'assets/images/emptystates/PackagesV2026-10-23.svg',
    PayrollHistory = 'assets/images/emptystates/PayrollHistoryV2026-10-23.svg',
    PracticeLog = 'assets/images/emptystates/PracticeLogV2026-10-23.svg',
    Repertoire = 'assets/images/emptystates/RepertoireV2026-10-23.svg',
    Reviews = 'assets/images/emptystates/CommentV2026-10-23.svg',
    StudioReports = 'assets/images/emptystates/StudioReportsV2026-10-23.svg',
    Students = 'assets/images/emptystates/StudentsV2026-10-23.svg',
    Mileage = 'assets/images/emptystates/LocationsV2026-10-23.svg',
    TrackMileage = 'assets/images/emptystates/MileageV2026-10-23.svg',
    Instructors = 'assets/images/emptystates/InstructorsV2026-10-23.svg',
    Tags = 'assets/images/emptystates/TagsV2026-10-23.svg',
    WebsiteNoMobile = 'assets/images/emptystates/Website-No-MobileV2026-10-23.svg',
    WebsiteSiteFiles = 'assets/images/emptystates/OnlineResourcesV2026-10-23.svg',
    WebsiteScriptCode = 'assets/images/emptystates/Website-Script-CodeV2026-10-23.svg',
    PageNotFound = 'assets/images/emptystates/404V2026-10-23.svg',
    FamilyContacts = 'assets/images/emptystates/Students-FamilyContactsV2026-10-23.svg',
    CalendarChangeEvent = 'assets/images/emptystates/ChangeEventV2026-10-23.svg',
    TechError = 'assets/images/emptystates/TechErrorV2026-10-23.svg'
}


export enum EmptyStateSize {
    Small = 'sb-empty-state-small',
    Medium = 'sb-empty-state-medium',
    Large = 'sb-empty-state-large',
}
